module.exports = __webpack_public_path__ + "img/my-officex2.56b0d3d9.png";